module.exports = __webpack_public_path__ + "static/img/81057B_R_all_20170815_LC.92e0ff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/81057B_R_all_20170815_LC.png
// module id = pCj/
// module chunks = 0